// Angular
import {
    AfterViewInit, ChangeDetectorRef, Component,
    OnDestroy,
    OnInit,
    Input
} from "@angular/core"
import { MatSnackBar } from "@angular/material"
import { MatDialog } from "@angular/material/dialog"
import { ActivatedRoute, NavigationEnd, Router,Params } from '@angular/router'
import _ from 'lodash'
// RxJS
import { of, Subject, Subscription } from 'rxjs'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
// Layout
import { SubheaderService } from '../../../../../core/_base/layout'
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service'
import { PageConfigService } from '../../../../../core/_base/layout/services/page-config.service'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { ConsultationService,AppService, DialogService, DocumentService, FormulaireService, StateService, UtilitaryService, ConnectionService, TiersService,DossierService } from '../../../../../services'
import { FoyerActionsDialog } from '../../../content/actions/foyer-actions-dialog/foyer-actions-dialog.component'
import { SuiviActionsDialog } from '../../../content/actions/suivi-actions-dialog/suivi-actions-dialog.component'
import { VisiteActionsDialog } from '../../../content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { InstructionActionsDialog } from '../../../content/actions/instruction-actions-dialog/instruction-actions-dialog.component'


import { AccesComponent } from '../../dialogs/acces-dialog/acces.component'
import { ChoiceCourrierComponent } from "../../dialogs/choice-courrier-dialog/choice-courrier.component"
import { ConfirmComponent } from '../../dialogs/confirm-dialog/confirm.component'
import { CourrierDialog } from '../../dialogs/courrier-dialog/courrier-dialog.component'
import { DoublonComponent } from '../../dialogs/doublon-dialog/doublon.component'
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component'

import { CreateConsultationDialogComponent } from "../../../content/actions/create-consultation-dialog/create-consultation-dialog.component"
import { LoadDialogComponent } from '../../dialogs/load-dialog/load.component'

const KEY = "subheader3"

@Component({
    selector: "atyl-subheader3",
    templateUrl: "./subheader3.component.html",
    styleUrls: ["./subheader3.component.scss"],
})
@Stringable({
    path: "views/partials/layout/subheader/subheader3",
    key: KEY,
})
export class Subheader3Component implements OnInit, OnDestroy, AfterViewInit {
    // constantes
    private TYPE_ACTION = 0;
    private TYPE_FORM = 1;
    
    @Input() tiers: any
    
	icon:any;
	
    // Public properties
    droits: any = [];
    userDroits: any = [];
    user: any
    today: number = Date.now();
    title: string = "";
    desc: string = "";
    breadcrumbs: Breadcrumb[] = [];
    colorization: string = "";
    quickmenu: any[] = [];
    etats: any[] = [];
    url: string = "";
    id: string = "";
    currentState: any

	isLoadAtert: boolean = true;
	
    demande: any
    dossier: any
    dossierWeb: any
    getCourrierFunc: any
    getImpressionFunc: any
    returnToDossierFunc: any
    createInstructionCompFunc: any
    creationForm: any
    creationCourrier: any
    addDocument: any
    creationFoyer: any
    creationFormDossierFunc: any
    creationFormMAMDossierFunc: any
    goToURL: any
    creationInstruction: any
    archiveDossier: any
    doublonDossier: any
    showAcces: any
    labelSub: any = "Actions";
    // new variables
    formulaires: any[] = [];
    consultationTypeList: any[] = [];
    // tabUserProfessions:any[] = []
    @StringableValues(KEY)
 	
    strings: any
    // Private properties
    private subscriptions: Subscription[] = [];
    /**
     * Component constructor
     *
     * @param subheaderService: SubheaderService
     */

    private alerteChangeEvent: Subject<boolean> = new Subject();
    constructor(
        private activatedRoute: ActivatedRoute,
        public subheaderService: SubheaderService,
        private router: Router,
        private connectionService: ConnectionService,
        private tiersService: TiersService,
		private dossierService: DossierService,
        private appService: AppService,
        private stateService: StateService,
        public dialog: MatDialog,
        private cdf: ChangeDetectorRef,
        private utilities: UtilitaryService,
        private snackBar: MatSnackBar,
        private formulaireService: FormulaireService,
        private documentService: DocumentService,
        private dialogService: DialogService,
        private consultationService: ConsultationService,
        private  pageConfigService: PageConfigService
    ) { }
    ngOnInit() {

		this.stateService.icon.subscribe((icon:any) => {
			console.log("Subheader3Component init icon",icon)
			this.icon=icon;
		})
        this.stateService.pages.subscribe((pages) => {
            let routeConfig = ""
            this.router.events.subscribe((res) => {
                this.quickmenu = []
                let resIsNavigationEnd = res instanceof NavigationEnd
                routeConfig = resIsNavigationEnd ? this.activatedRoute.firstChild.routeConfig.path : null
                let hasPages = pages.length > 0
                if (resIsNavigationEnd && hasPages) {
                    let _params={}
                    
                    this.activatedRoute.firstChild.params.subscribe(params => {
                       _params=params;
                       
                    });
                    
                    
              
                    
                    this.handelAction(pages, routeConfig,_params)
                }
            })
        })
        /**
         * @var type :any
         * @var page :any
         * popup the create form dialog
         */
        this.creationForm = (button: any, page: any) => {
	       // console.log("creationForm",button,page);
            if (page.confirm) {
                this.dialogService.open(ConfirmComponent, {
                    draggable: true,
                }, (res: any) => {
                    res === "true" && this.getFormulaire(button, page)
                })
            } else this.getFormulaire(button, page)
        }
        this.addDocument = (type: any, page: any,pageUrl: any) => {
			//console.log("addDocument",type,page,pageUrl)
            if (page==null || !page.confirm) {
                this.getDocument(type, page)
            } else {
                this.dialogService.open(ConfirmComponent, {
                    draggable: true,
                }, (res: any) => {
                    res === "true" && this.getDocument(type, page)
                })
            }

        }

        // create Courrier action
        this.creationCourrier = (type: any, page: any) => {
            if (page==null || !page.confirm) {
                this.getChoiceCourrier(type,page)
            } else {
                this.dialogService.open(ConfirmComponent, {
                    draggable: true,
                    minimizable: true,
                    maximizable: true,
                    width: '40vw',
                    height: '50vh'
                }, (res: any) => {
                    res === "true" && this.getChoiceCourrier(type,page)
                })
            }

        }

			
		
		
        // this.creationCourrier = (type: any, page: any) => {
        //     if (!page.confirm) {
        //         this.getCourrier(type, page);
        //     } else {
        //         this.dialogService.open(ConfirmComponent, {
        //             draggable: true,
        //             minimizable: true,
        //             maximizable: true,
        //             width: '40vw',
        //             height: '50vh'
        //         }, (res: any) => {
        //             res === "true" && this.getCourrier(type, page);
        //         });
        //     }

        // };

        this.creationFoyer = (type: any, page: any) => {
            if (!page.confirm) {
                this.getFoyer(type, page)
            } else {
                this.dialogService.open(ConfirmComponent, {
                    draggable: true,
                }, (res: any) => {
                    res === "true" && this.getFoyer(type, page)
                })
            }
        }

        this.goToURL = (url) => {
            this.router.navigate(["/home/" + url])
        }
        
        if (this.tiers!=undefined && 
        this.tiers) {
			
			 this.dossier = this.tiers
	         this.labelSub = "Actions"
	         this.showAcces = () => {
	                this.displayAcces()
	         }
			 
			 if (this.title=="Dossier" 
 				&& this.dossier!=undefined 
 				&&  this.dossier
 				&&  this.dossier.tiers!=undefined
 				&&  this.dossier.tiers.type_libelle!=undefined
 			     )
 				this.title +="<br>"+this.dossier.tiers.type_libelle; 
			 
	         
		} else
	        this.stateService.dossier.subscribe((dossier: any) => {
	            this.dossier = dossier
	            this.labelSub = "Actions"
	            this.showAcces = () => {
	                this.displayAcces()
	            }
				if (this.title=="Dossier" 
	 				&& this.dossier!=undefined 
	 				&&  this.dossier
	 				&&  this.dossier.tiers!=undefined
	 				&&  this.dossier.tiers.type_libelle!=undefined
	 			     )
	 				this.title +="<br>"+this.dossier.tiers.type_libelle; 
				
				
	        })
       // this.getFormulaires()
        this.stateService.dossierWebamat.subscribe((dossier) => {
            this.dossierWeb = dossier
            this.doublonDossier = () => {
                this.displayDoublon()
            }
        })
        this.stateService.demande.subscribe((demande) => {
            this.demande = demande
            this.getCourrierFunc = () => {
                this.getCourrier(demande.ID, this.currentState.typeForm)
            }
            this.getImpressionFunc = () => {
                let formPrint
                _.forEach(demande.forms, (form, index) => {
                    if (form.key === this.currentState.typeForm)
                        formPrint = form
                })
                this.getImpression(
                    this.currentState.typeForm,
                    demande.ID,
                    formPrint.ID
                )
            }
          /*
            this.creationInstruction = (type, options) => {
                let toConfirm = true
                Object.keys(this.user.droits).forEach((droit) => {
                    if (
                        droit === "AUCUNE_CONFIRMATION" ||
                        droit === "AUCUNE_CONFIRMATION_PROCEDURE"
                    ) {
                        toConfirm = false
                    }
                })
                if (options.confirm && toConfirm) {
                    this.dialogService.open(ConfirmComponent, {
                        draggable: true,
                    }, (res: any) => {
                        if (res === "true") {
                            this.createInstruction(type, options)
                        }
                    })
                } else this.createInstruction(type, options)
            }
            */
			this.archiveDossier = (type: any, page: any,pageUrl: any) => {
									let retour:string =(page.retour!=undefined) ? page.retour : "recherche";
									if(page.confirm!=undefined){
										
										let label:string=(this.dossier.archive!=undefined && this.dossier.archive==1) ? "Etes-vous sûr de vouloir désarchiver ce dossier ?":"Etes-vous sûr de vouloir archiver ce dossier ?"
										let dt:any={
											libelle : label
										}
								//		console.log("archiveDossier",dt);
										const confDialogRef = this.dialog.open(ConfirmComponent,{data :  dt});
										confDialogRef.afterClosed().subscribe(res => {
											if(res === 'true')
												this.archivateDossier(retour);
										});
									}else
										this.archivateDossier(retour);
			}
        })

        this.stateService.droitsApp.subscribe((droits) => {
            if (droits === Object(droits)) this.droits = [droits]
            else this.droits = droits
        })

        this.stateService.user.subscribe((user) => {
            if (user.droits === Object(user.droits))
                this.userDroits = [user.droits]
            else this.userDroits = user.droits
            this.user = user
        })
    }

    /**
     * After view init
     */
    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.subheaderService.title$.subscribe((bt) => {
                // breadcrumbs title sometimes can be undefined
                 //console.log("subheaderService BreadcrumbTitle before",bt)
                if (bt) {
                   console.log("subheaderService BreadcrumbTitle",bt)
                    Promise.resolve(null).then(() => {
						this.title = bt.title;

                        if (bt.desc == null) {
                            this.stateService.subHeader.subscribe(subHeader => this.desc = subHeader)
                        }
                        else {
                            this.desc = bt.desc
                        }
                    })
                }
            })
        )
        this.subscriptions.push(
            this.subheaderService.breadcrumbs$.subscribe((bc) => {
                Promise.resolve(null).then(() => {
                    this.breadcrumbs = bc
					console.log("subheaderService BreadcrumbTitle before",this.breadcrumbs)
                    if (
                        this.breadcrumbs[0] &&
                        this.breadcrumbs[0].page == "mam"
                    )
                        this.colorization = "mam-header"
                    else if (
                        this.breadcrumbs[0] &&
                        this.breadcrumbs[0].page == "eaje"
                    )
                        this.colorization = "eaje-header"
                    else this.colorization = ""
                })
            })
        )

        // this.subscriptions.push(
        // 	this.stateService.etats.subscribe((etats) => {
        // 		this.etats = [];
        // 		_.forEach(etats, (etat, index) => {
        // 			let change = () => {
        // 				this.changeState(etat.name, etat.label);
        // 			};
        // 			let formcall = () => {
        // 				this.loadForm(
        // 					this.demande.type.ID,
        // 					etat.form.key,
        // 					this.demande.ID,
        // 					etat.name
        // 				);
        // 			};
        // 			if (!etat.form) {
        // 				this.etats.push({
        // 					icon: "",
        // 					libelle: etat.label,
        // 					etatId: etat.name,
        // 					etatLabel: etat.label,
        // 					action: change,
        // 				});
        // 			} else {
        // 				this.etats.push({
        // 					icon: "",
        // 					libelle: etat.label,
        // 					etatId: etat.name,
        // 					etatLabel: etat.label,
        // 					action: formcall,
        // 				});
        // 			}
        // 		});
        // 		if (this.etats.length > 0) {
        // 			this.quickmenu.push({
        // 				page: "assistmat",
        // 				icon: "la la-exchange",
        // 				libelle: "Changement état",
        // 				link: "etats",
        // 				children: this.etats,
        // 			});
        // 		}
        // 		this.utilities.log(this.etats, this.quickmenu);
        // 	})
        // );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this.subscriptions.forEach((sb) => sb.unsubscribe())
    }

    getCourrier(iddemande: string, codeform: string): void {
        this.dialogService.open(CourrierDialog, {
            data: {
                typeDemande: this.demande,
                state: this.currentState,
            },
            height: "60vh",
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
           
				
						 if (result!=undefined && result
			                && result.ziFile!=undefined 
			                && result.ziFile.url!=undefined 
			                 && result.ziFile.url
			                ) {
							//	window.open(result.zipFile.url,' _blank');
								
								const dial=this.dialogService.open(LoadDialogComponent, {
									               data: {
									                   url: result.zipFile.url
									               },
												   height: "95vh",
												   width: "80%",
												   minimizable: true,
												   maximizable: true,
												   draggable: true,
									           	}, (res: any) => {
									               
									           	})
							}
                  
                   
	                    let _refresh={
							type: "courrier",
							data:{
					                typeDemande: this.demande,
					                state: this.currentState,
					            }
						};
	                   
	                    this.stateService.updateRefresh(_refresh)
                    
                
				
			 

        })
    }

    getChoiceCourrier(iddemande: string, codeform: string): void {
         const dialogRef =this.dialogService.open(ChoiceCourrierComponent, {
            data: {
                typeDemande: this.demande,
                state: this.currentState,
                dossier: this.dossier,
                droitsObjets: this.user.droitsObjets
            },
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
        
        const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
         //    console.log("SubheaderCompennt ChoiceCourrierComponent",result);
             if (result!=undefined && result
	                && result.zipFile!=undefined 
	                && result.zipFile.url!=undefined 
	                &&result.zipFile.url
	                ) {
					//	window.open(result.zipFile.url,' _blank');
					const dial=this.dialogService.open(LoadDialogComponent, {
						               data: {
						                   url: result.zipFile.url
						               },
									   height: "95vh",
									   width: "80%",
									   minimizable: true,
									   maximizable: true,
									   draggable: true,
						           	}, (res: any) => {
						               
						           	})
			}
            
            let _refresh={
							type: "courrier",
							data: result
						};
	                   
	        this.stateService.updateRefresh(_refresh)
	    }
	  )
    }




    getImpression(code: string, iddemande: string, formId: string): void {
        this.appService
            .getImpression(iddemande, code, formId)
            .then((impression) => {
                window.open(impression.result[0].url, "_blank")
            })
    }
    changeState(idTransition: string, labelTransition): void {
        of(
            window.confirm(
                "Voulez-vous changer l'état de la demande vers " +
                labelTransition
            )
        ).subscribe((bool) => {
            if (bool) {
                this.appService
                    .changeEtatDemande(this.demande.ID, idTransition)
                    .then((result) => {
                        this.router.navigate([
                            "/home/assistmat/" + this.demande.dossier.ID,
                        ])
                    })
            }
        })
    }
    loadForm(
        typeDemande: string,
        typeForm: string,
        idDemande: string,
        etat: string
    ): void {
        this.router.navigate([
            "/home/formulaire/" +
            typeDemande +
            "/" +
            typeForm +
            "/" +
            idDemande +
            "/" +
            etat,
        ])
    }
    returnToDossier() {
        let id = this.demande.dossier.ID
        if (this.demande.dossier.tiers.type == "ASSMAT") {
            this.stateService.updateDemande("")
            this.router.navigate(["home/assistmat" + "/" + id])
        }
    }
   
    createInstructionOld(type: string, options?: any): void {
        this.appService.getNewInstruction(type, options).subscribe((res: JSONRpcResponse) => {
            if (!this.dossier.instructions) this.dossier.instructions = []
            this.appService
                .createNewInstruction(
                    type,
                    this.dossier.ID,
                    res.result,
                    options
                )
                .subscribe((resCreate: JSONRpcResponse) => {
                    this.dossier.instructions.unshift(resCreate.result)
                    this.stateService.updateDossier(this.dossier)
                    if (options.index_tab) {
                        this.stateService.updateRefresh(options.index_tab)
                        this.stateService.selectNewCreatedInstruction(
                            resCreate.result
                        )
                    } else {
                        this.stateService.updateRefresh(2)
                        this.stateService.selectNewCreatedInstruction(
                            resCreate.result
                        )
                    }
                })
        })
    }
   
    displayAcces(): void {
        this.dialogService.open(AccesComponent, {
            data: {
                id: this.dossier ? this.dossier.ID : 0,
                email: this.dossier.access ? this.dossier.access.email : "",
                email_valid: this.dossier.access
                    ? this.dossier.access.email_valid
                    : false,
                password: this.dossier.access
                    ? this.dossier.access.passe
                    : false,
            },
            draggable: true,
            resizable: true
        }, (result: any) => {
            if (result) {
                this.utilities.log(result)
            }
        })

    }
    displayDoublon(): void {
        this.dialogService.open(DoublonComponent, {
            data: {
                id: this.dossierWeb ? this.dossierWeb.tiers.ID : 0,
            },
            height: "80vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result) => {
            if (result) {
                this.utilities.log(result)
                this.snackBar.open("Changement effectué")
                this.router.navigate(["/home/webamat"])
            }
        })

    }
    getFormulaire(button: any, page: any): void {
        this.dialogService.open(
            FormDialogFormulaireWithSFComponent,
            {
                data: {
                    idAForm: button.IdForm,
                    dossier: this.dossier ? this.dossier : "",                    
                    create: true,
                    closeWhenValidate: true,
                    action: button,
                    v3: true,
                },
                height: "90vh",
                width: "90vw",
                draggable: true,
                resizable: true,
                minimizable: true,
                maximizable: true,
            }, (result: any) => {
                if (result.result) {
                    this.utilities.log("subhearder getFormulaire", result.result,page)
                   
                   // this.stateService.updateRefresh("Success")
                   //  console.log(res)
                   
	                    let _refresh={
							type: "formulaire",
							data:result.result
						};
	                   
	                    this.stateService.updateRefresh(_refresh)
                    
                    
                    
                    if (page.redirect!=undefined
                     && result.result.ID!=undefined) {
                        let _ops:any= {}
						
                        this.formulaireService
                        	.get(result.result.ID,_ops)
                        	.subscribe((dmform: JSONRpcResponse) => {
				        //      console.log("formulaire",dmform);
				              
				              if (dmform.result.demande!=undefined
				              && dmform.result.demande.dossier!=undefined
				              && dmform.result.demande.dossier.tiers!=undefined
				              && dmform.result.demande.dossier.tiers.type!=undefined
				               && dmform.result.demande.dossier.tiers.dossierID!=undefined
				              ) {
								let route:string="/home/"+page.redirect;
								route=route.replace(":type",dmform.result.demande.dossier.tiers.type);
					            route=route.replace(":id",dmform.result.demande.dossier.tiers.dossierID);
							//	console.log("formulaire route",route)
									 this.router.navigate([
				                            route
				                        ])
					
					
								}
				            
				            /*
                        this.router.navigate([
                            "/home/" +
                            page.redirect +
                            "/" +
                            result.result.demande.dossier.ID,
                        ])
                        */
				
				        })
                  }      
                }
            })
    }
    getDocument(id: string, page: any): void {
        this.dialogService.open(UploadFileDialogComponent, {
            data: {
                formulaires: this.formulaires,
                slider: {
                    enabled: true,
                    dossier: this.dossier,
                    components: {
                        formulaires: true,
                        interventions: true,
                    }

                },
                droitsObjets: this.user.droitsObjets
            },
            height: "80vh",
            width: "45vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            if (result != undefined && result != "") {
                /* let document: any= {
                     demandeid: 0,
                     value: result.selectedDocument.value,
                     status:  result.currentEtat,
                     
                   };
                  */
                let document: any = {
                    ID: 0,
                    demandeid: 0,
                    document: result.selectedDocument.document,
                    value: result.selectedDocument.value,
                    desciption: null,
                    status: result.currentEtat,
                    parameter: result.selectedDocument.parameter,
					formulaires: result.selectedFormulaires
                }
                document.value.parameter = result.selectedDocument.parameter
                /*
                
                result.selectedDocument.value;
                 document.status= result.currentEtat;
                 document.demandeid= 0;
                 document.document= result.selectedDocument.document;
                 document.value=result.selectedDocument.value;
                 */
                // document["demandeid"]=0;
                /* document]value = result.selectedDocument.value;
                 document.value.parameter = result.selectedDocument.parameter;
                 */
                if (result.selectedDocument.description)
                    document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
                //  document.parameter=result.selectedDocument.parameter;
                
                if (result.selectedDocument.demandeID) {
                    document.demandeid = result.selectedDocument.demandeID;
                }

                //  document.value.archive = JSON.parse(result.archive);
                // document.status = result.currentEtat;
                this.documentService.setDocumentByInstruction(
                    document.demandeid, document, this.dossier.ID).subscribe((res: JSONRpcResponse) => {
                    //    console.log("after document", res)
						if (res.error) {
													
													let mess:string=(res.error.data!=undefined) ? res.error.data : "Erreur importation document";
													this.snackBar.open(mess, '', {
																					duration: 2500,
																					panelClass: ['error-snackbar']
																				});
												}
												else {
								this.stateService.documentsUpdate(true)
							}	
                    })
                 
	                    let _refresh={
							type: "document",
							data:document
						};
	                   
	                    this.stateService.updateRefresh(_refresh)
                      
                    
            }
        })

    }
    CheckDroitsApplication(type: any, element: any, action: any): boolean {
        let response = true
        let selectedDroit
        if (this.droits && this.droits.length > 0 && element) {
            this.droits.forEach((droit) => {
                droit.acces.forEach((acces) => {
                    if (
                        acces.instruction &&
                        element === acces.instruction.key &&
                        !acces.demande_type &&
                        !acces.instruction_etat
                    ) {
                        selectedDroit = acces
                    }
                })
            })
        }
        if (
            type === "instruction" &&
            selectedDroit &&
            selectedDroit.instruction
        ) {
            if (
                !selectedDroit.demande_type &&
                !selectedDroit.instruction_etat &&
                !selectedDroit.form &&
                !selectedDroit.document &&
                !selectedDroit.courrier &&
                selectedDroit.instruction.key === element
            )
                response = selectedDroit[action]
            if (action === "u" && !_.isEmpty(this.dossier)) {
            }
        }
        return response
    }

    /*
    CheckDroitsUser(): boolean {
        let response = true
        if (this.userDroits && this.userDroits.length > 0) {
            Object.keys(this.userDroits[0]).forEach((userDroitIndex) => {
                if (
                    this.router.url.toUpperCase().indexOf(userDroitIndex) !== -1
                ) {
                    response = this.userDroits[0][userDroitIndex].w
                }
            })
        }
        return response
    }*/

    optionsIfNotEmpty(button: any) {
        return button.parametre.options ? button.parametre.options : null
    }
    handelAction(pages: any, routeConfig: any, _params:any) {
        let grpButton=[];
        let grpWithoutButton=[];
        pages.forEach((page) => {
          // console.log('page url action', page.url, routeConfig)
            if (page.url === routeConfig) {
				  this.isLoadAtert=(
					page.key!=undefined 
					&& page.key=='DOSSIERACTION' )
                  console.log('page ', page,this.isLoadAtert)
                
               /*
                grpButton["PRINCIPAL"]={
                    libelle:"Principal",
                    children:[]
                };
                */
                page.actions.forEach((action: any) => {
                   //  console.log("action",action.tiers_type,routeConfig,_params)
                   if (action.sous_groupe) {
                      
                       if (grpButton[action.sous_groupe.key]==undefined)
                           grpButton[action.sous_groupe.key]={
                                        libelle:  action.sous_groupe.libelle,
                                        children:[],
                                        link: 'etats'
                                    };
                   } 
                });     
                //console.log("Subheader3Componentnt page",page)
                
                page.actions.forEach((action: any) => {
                    let button = action
                   /* if (!action.rights.r)
                    	console.log("Subheader3Componentnt action",action)
                    	*/
                    if (action.rights.r) {
                       
                    /*if (button.type == "link") {
                        button.action = () => {
                            return this.goToURL(button.parametre.url)
                        }
                    }*/
                        let typeObj = "action";
	                    if (button.parametre) {
	                        switch (button.parametre.action) {
                                case "link":
		                        	button.action = () => {
	                                    return  this.goToURL(button.parametre.url)
	                                    
	                                }
		                            
		                        	break;
	                            case "createForm":
                                    typeObj = "formulaire";
	                                button.action = () => {
	                                    return this.creationForm(
	                                        button,
	                                        this.optionsIfNotEmpty(button)
	                                    )
	                                }
	                                break;
	
	                            case "createCourrier":
	                                button.action = () => {
	                                    return this.creationCourrier(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button)
	                                    )
	                                }
	                                break;
	
	                            case "addDocument":
	                                button.action = () => {
	                                    return this.addDocument(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button),
	                                         page
	                                    )
	                                }
	                                break;
	                            case "createFoyer":
	                                button.action = () => {
	                                    return this.creationFoyer(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button)
	                                    )
	                                }
	                                break;
	                            case "addToFoyer":
	                                button.action = () => {
	                                    return this.addToFoyer(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button)
	                                    )
	                                }
	                                break;
	                            case "createSuivi":
	                                button.action = () => {
	                                    return this.creationSuivi(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button)
	                                    )
	                                }
	                                break;
	                            case "createVisite":
	                                button.action = () => {
	                                    return this.creationVisite(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button),
	                                        page
	                                    )
	                                }
	                                break;
	                            case "createConsultation":
	                                button.action = () => {
	                                    return this.creationConsultation(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button),
	                                        page
	                                    )
	                                }
	                                break;
	                            case "createInstruction":
                                    typeObj = "instruction";
	                                button.action = () => {
	                                    return this.createInstruction(
	                                        button.parametre.type,
	                                        button.parametre.instruction,
	                                        this.optionsIfNotEmpty(button),
	                                        page
	                                    )
	                                }
	                                break ; 
								case "archive":
	                                button.action = () => {
	                                    return this.archiveDossier(
	                                        button.parametre.type,
	                                        this.optionsIfNotEmpty(button),
	                                         page
	                                    )
	                                }
			                         break;	
	                        }
                            
	                    } else {
	                       // console.log(button)
                            typeObj = "formulaire";
	                        button.action = () => {
	                            return this.creationForm(button, page)
	                        }
	                    }
                        this.applyRightsObj(button,typeObj);
	                    
	                 if (this.checkToAddButton(action.tiers_type,_params,button)) {   
	                         if (button.sous_groupe &&
	                            grpButton[button.sous_groupe.key]!=undefined) {
	                            grpButton[button.sous_groupe.key].children.push(button)
	                       } else
	                            grpWithoutButton.push(button)
	                   } 
	                }       
                   // this.quickmenu.push(button)
                })
            }
        })
        
        console.log("subheader grpButton",grpButton,grpWithoutButton )
        this.quickmenu=grpWithoutButton;
        
       Object.values(grpButton).forEach((value: any) => {
          //console.log("grpButton",value);
          this.quickmenu.push(value);    
        });
        console.log("subheader quickmenu",this.quickmenu);
		this.cdf.detectChanges();
        
    }
    checkToAddButton(tiers_type:any[],_params:any,button:any) {
        let added:boolean=true;
        if (_params.type!=undefined && tiers_type.length>0 ) {
            added=false;
            for(let i=0;i<tiers_type.length;i++) {
                if (tiers_type[i].type !=undefined
                  && tiers_type[i].type.code !=undefined
                 && tiers_type[i].type.code===_params.type)
                   added=true;
            }
           // console.log("checkToAddButton",added,tiers_type,_params.type,button)
        }
        return added;
        
    }

    getFormulaires(): any {
        this.formulaireService.list({ dossierId: this.dossier }).subscribe((formulaires: JSONRpcResponse) => {
            this.formulaires = formulaires.result

        })
    }
    getFoyer(type: any, page: any) {
        this.dialogService.open(FoyerActionsDialog, {
            data: {
                action: "create",
                dataType: "foyer",
                code: type,
                dossier: this.dossier,
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
    addToFoyer(type: any, page: any) {

        this.dialogService.open(FoyerActionsDialog, {
            data: {
                action: "add",
                dataType: "foyer",
                code: type,
                dossier: this.dossier,
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
    creationSuivi(type: any, page: any) {
        this.dialogService.open(SuiviActionsDialog, {
            data: {
                action: "create",
                dataType: "suivi",
                code: type,
                dossier: this.dossier,
                title: "Création d'une intervention",
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            this.stateService.updateRefresh(true)
        })
    }
    creationVisite(type: any, page: any, pageUrl: any) {
		var urls:any[]=[];
		if (page!=undefined && page 		
		&& page.nodossier!=undefined
		&& page.nodossier
		&& Array.isArray(page.nodossier)
		  )
		  urls=page.nodossier;
		  
		var d:any=undefined;
		if (pageUrl.url==undefined
		|| (pageUrl.url && !urls.includes(pageUrl.url))
		/*|| (pageUrl.url!="consultation" && pageUrl.url!="consultation/:id")*/		
		)
			d=this.dossier;
		
		var isrefreshDossier:boolean= (pageUrl.url!=undefined && pageUrl.url
			&& pageUrl.url=="dossier/:type/:id"
			) ;
			
			
		let dataVs:any= {
                action: "create",
                dataType: "rdv",
                code: type,
                dossier: d,
				page: pageUrl,
                title: "Création d'un rendez-vous",
                create: true,
            };
		console.log("creationVisite",type,page,pageUrl,urls,dataVs);
        this.dialogService.open(VisiteActionsDialog, {
            data: dataVs,
            height: "95vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (res: any) => {
//                   console.log(res)
                    
	                    let _refresh={
							type: "visite",
							data:res
						};
	                   // console.log("subheader VisiteActionsDialog",res,isrefreshDossier,pageUrl)
	                   if (isrefreshDossier)
						 	this.stateService.updateRefresh(_refresh)
	                   /* if (res.consultation!=undefined)
                    		this.stateService.updateConsultation(res.consultation);
                    */
           })

    }
    
    loadConsultationType() {
       
    }

    _hasCommonElement(array1, array2) {
        return array1.some(element => array2.includes(element));
    }
    
    creationConsultation(type: any, page: any, pageUrl: any) {
        const tabUserProfessions = [];
        var tabConsultationListTypeProfessions = [];
       
        
        this.tiersService.getProfessionsString().subscribe((res: JSONRpcResponse) =>{
            if (res) {
                this.user = res.result;

                if (this.user && this.user.professions) {
                    this.user.professions.forEach((pro: any) => {
                        if (pro) {
                            tabUserProfessions.push(pro.libelle);
                        }
                        this.cdf.detectChanges()
                    });
                }
            } 

            let _opt = {"visiteType": "consultation"};
            this.consultationService.getConsultationTypeList(_opt).subscribe((res: JSONRpcResponse) => {
                
                res.result.forEach(aff => {
                    if(!aff.noDisplay){
                        tabConsultationListTypeProfessions = []; 
                        aff.professions.forEach((tri:any) => {
                            if(tri){
                                tabConsultationListTypeProfessions.push(tri.libelle);
                            }
                        });
                        if(this._hasCommonElement(tabUserProfessions,tabConsultationListTypeProfessions)){
                            this.consultationTypeList.push(aff);
                        }
                        tabConsultationListTypeProfessions = [];
                    }
                    this.cdf.detectChanges();
                });
                this.cdf.detectChanges()
            })

            this.cdf.detectChanges()
        });

        let dataCs={
            action: "create",
            dataType: "consultation",
            code: type,
            dossier: this.dossier,
            title: "Création d'une séance",
            page: pageUrl,
            create: true,
            types:this.consultationTypeList,
            updateOnCreate: false,
        }
          
		var isrefreshDossier:boolean= (pageUrl.url!=undefined && pageUrl.url
					&& pageUrl.url=="dossier/:type/:id"
					) ;
		  
        this.dialogService.open(CreateConsultationDialogComponent, {
            data: dataCs,
            height: "95vh",
            width: "80vw",
            draggable: true,
            maximizable: true,
            minimizable: true,
            resizable: true,
        }, (res: any) => {
        console.log(res)
            this.consultationTypeList = [];
            let _refresh={
                type: "consultation",
                data:res
            };
            console.log("subheader CreateConsultationDialogComponent",res,isrefreshDossier,pageUrl)
			if (isrefreshDossier)
			 	this.stateService.updateRefresh(_refresh)
            if (res.result){
                this.stateService.updateConsultation(res.result);
            } 
        
        })
        this.cdf.detectChanges();
    }
    
    
    
    createInstruction(type: any,instruction:any, page: any, pageUrl: any): void {
        console.log("createInstruction type:",type,"\ninstruction:",instruction,"\ndossier",this.dossier);
        let dataIns={
             action: "create",
            dataType: "consultation",
            code: type,
            dossier: this.dossier,
            title: "Création d'une procédure",
            create: true,
            instruction_type: instruction
            }
        this.dialogService.open(InstructionActionsDialog, {
                    data: dataIns,
                    width: '50vw',
                    draggable: true,
                    maximizable: true,
                    minimizable: true,
                    resizable: true,
                }, (res: any) => {
                    console.log(res)
                    if (res) {
	                    let _refresh={
                            type:"instruction",
                            data:{
                              ID:res,
                              historique:false
                            }
						};
	                   
	                    this.stateService.updateRefresh(_refresh)
                    }
                    
           })
    }

    applyRightsObj(obj: any, type: string) {
       // console.log("btn_rights",obj,type)
      //  console.log("btn_rights_USER",this.user.droitsObjets)
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        switch (type) {
            case "instruction":
                key = obj.parametre.instruction!=undefined && obj.parametre.instruction  ?obj.parametre.instruction: null;
                break;
            case "formulaire":
				if (obj.CodeForm!=undefined)
                	key = obj.CodeForm;
                break;
            case "action":
			    if (obj.key!=undefined)
                	key = obj.key;
                break;
        }
    
        if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
            if (this.user.droitsObjets[type][key] != undefined) {
                rg = this.user.droitsObjets[type][key];
            }
        }

        //on récupère d'abord les droits de l'action et s'ils sont true on vérifie que les droits de l'objet le sont aussi
        if(type!="action"){
            let actionRights = this.applyRightsObj(obj,"action").objRights;
//            console.log("ACTION_RIGHTS",actionRights);
            let finalRights = {};
            for(let right of ["r","w","x"]){
            //    console.log("btn_rights_ACTRIGHTS",right,actionRights[right],rg[right])
                finalRights[right] = actionRights[right]? rg[right]: false
            }
            rg = finalRights;
        }

        obj.objRights = rg;
    
        if (obj.editable) {
            obj.editable = rg.w;
        }
        return obj;
    }
	
	archivateDossier(retour): void {
		this.dossierService.archive(this.dossier.ID).subscribe((res) => {
			this.router.navigate(['/home/'+retour]);
		});
	}
    
    
}
